import { useContext, useMemo } from 'react';
import * as _ from 'lodash';
import { DataContext } from '../context/data-context';
import { useApi } from './api';

export const getLeadersWithTopListNumber = (
  leadersNoToplistNumber,
  sort = 'DESC'
) => {
  const groupedLeaders = _.groupBy(leadersNoToplistNumber, 'stat');

  const keys = Object.keys(groupedLeaders).sort((a, b) => {
    if (sort === 'ASC') {
      return a - b;
    }

    return b - a;
  });

  keys.forEach((key, index) => {
    groupedLeaders[key].forEach((leader) => {
      if (index === 0) {
        // eslint-disable-next-line no-param-reassign
        leader.topListNumber = 1;
      }

      const previousIndexes = Array.from(
        { length: index - 0 },
        (a, i) => 0 + i
      );
      // eslint-disable-next-line no-shadow
      const filteredKey = keys.filter((k, index) =>
        previousIndexes.includes(index)
      );
      const previousLeaders = filteredKey.map((k) => groupedLeaders[k]).flat();
      const topListNumber = previousLeaders.length + 1;

      // eslint-disable-next-line no-param-reassign
      leader.topListNumber = topListNumber;
    });
  });

  const leaders = keys.map((key) => groupedLeaders[key]);
  return leaders.flat();
};

export const useLeaders = (type, limit = 10) => {
  const { currentSeason } = useContext(DataContext);
  const [data, loading, error] = useApi(`leaders?season=${currentSeason}`);

  const list = useMemo(
    () =>
      data
        ? getLeadersWithTopListNumber(data[type])
            ?.slice(0, limit)
            .filter((leader) => leader.stat > 0)
            .map((leader) => {
              return {
                ...leader.player,
                stat: leader.stat,
                matches: leader.matches,
                topListNumber: leader.topListNumber,
                id: parseInt(leader.player.id, 10),
              };
            })
        : [],
    [type, limit, data]
  );

  return [list, loading, error];
};

export function useLeadersInTeam(abbrv) {
  return useApi(`leaders-in-team?id=${abbrv}`);
}
